"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var FlexPageIntro = function FlexPageIntro(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    topText = _ref.topText,
    noTop = _ref.noTop,
    noBottom = _ref.noBottom;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: noTop && 'calc(-1 * var(--space-xxl))',
      marginBottom: noBottom && 'calc(-1 * var(--space-xxl))'
    }
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center max-width-xxs margin-auto"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-primary d8-u-ls-sm d8-u-text-bold"
  }, topText), /*#__PURE__*/_react["default"].createElement("h2", null, heading), /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-top-xl"
  }, subheading))));
};
FlexPageIntro.propTypes = {
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  noTop: _propTypes["default"].bool,
  noBottom: _propTypes["default"].bool
};
var _default = exports["default"] = FlexPageIntro;